import { MAX_QUESTION_LENGTH } from './constants'
import { SlideQuestionErrorKeys } from './keys'
import { type ValidationError, type Validator } from './types'

export const validateCustomPoll: Validator = async (context, question) => {
  const errors: ValidationError[] = []
  const trimmedQuestion = question.question?.trim()

  if (!trimmedQuestion) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_custom_poll_missing,
    })
  } else if (trimmedQuestion.length > MAX_QUESTION_LENGTH) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_custom_poll_too_long,
    })
  }

  const nonEmptyAnswers = question.answers?.filter((a) => a.trim() !== '') || []

  if (nonEmptyAnswers.length === 0) {
    errors.push({
      field: 'answers',
      key: SlideQuestionErrorKeys.question_custom_poll_no_answers,
    })
  }

  return errors
}
